<template>

    <div class="container">

        <div class="mb-2">
            <inertia-link :href="route('admin.orders.index')">
                <i class="bi bi-arrow-left"></i>
                {{ __('Zur Übersicht') }}
            </inertia-link>
        </div>

        <div class="mb-4">
            <h1>{{ __('Bestellung erstellen') }}</h1>
        </div>

        <div class="">
            <form @submit.prevent="form.post(route('admin.orders.store'))">
                <form-fields :form="form" 
                             :order-status-options="orderStatusOptions"
                             :countries="countries"
                             :customers="customers"
                             />
            </form>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'countries',
            'customers',
            'orderStatusOptions',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    customer_id: null,
                    customer_number: null,
                    supplier_order_number: null,
                    order_token: null,
                    order_status: 'new',
                    shipped: null,
                    shipping_date: null,
                    tracking_url: null,
                    tracking_code: null,
                    subtotal: null,
                    total: null,
                    tax: null,
                    delivery: null,
                    delivery_tax: null,
                    payment_method_id: null,
                    delivery_option_id: null,
                    notes: null,
                    created_at: null,
                    delivery_address_same_as_billing_address: true,
                    order_items: [{}],
                    billing_address_data: {
                        country_id: null
                    },
                    delivery_address_data: {
                        country_id: null
                    },
//                    customer_data: {},
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>